import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './../../context/auth-context.jsx';
import { resolvePermissionRouteAccess } from '../../modules/system-navigation/model/permission-visibility.js';

function PermissionRoute({ children, requiredPermission, requiredAnyPermission, redirectTo = '/dashboard' }) {
  const { isLoading, permissions } = useAuth();
  const access = resolvePermissionRouteAccess({
    isLoading,
    permissions,
    requiredPermission,
    requiredAnyPermission,
  });

  if (access === 'loading') {
    return <div className="text-muted">Loading permissions...</div>;
  }

  if (access === 'redirect') {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default PermissionRoute;
